export default "__VITE_ASSET__e9875a91__"